export type FaqItem = { q: string; a: string };
export type FaqCategory = { category: string; items: FaqItem[] };

export const faqCategories: FaqCategory[] = [
  {
    category: "Angebot & Preise",
    items: [
      {
        q: "Kostet eine Besichtigung etwas?",
        a: "Nein, die Vor-Ort-Besichtigung ist für Sie immer kostenlos und unverbindlich. Wir besichtigen das Objekt, erfassen Volumen, Zugang, Stiegenhaus, Möbellift-Bedarf und Sperrgut – und erstellen daraus innerhalb von 24 Stunden ein schriftliches Angebot.",
      },
      {
        q: "Was kostet eine Entrümpelung?",
        a: "Jeder Auftrag ist individuell – seriös können wir den Preis erst nach der Besichtigung nennen. Richtwerte: Kleinwohnung bis 40 m² ab 590 €, 2-Zimmer ab 890 €, 3-Zimmer ab 1.290 €, Einfamilienhaus ab 2.490 €. Gut erhaltene Möbel oder Antiquitäten rechnen wir an und reduzieren so den Endpreis um bis zu 30 %.",
      },
      {
        q: "Was kostet ein Umzug?",
        a: "Lokale Umzüge: 1-Zimmer ab 490 €, 2-Zimmer ab 790 €, 3-Zimmer ab 1.190 €, Einfamilienhaus ab 1.690 €. Inklusive Verpackungsmaterial, Decken, Demontage und Montage. Möbellift, Halteverbot oder Klaviertransport berechnen wir transparent extra.",
      },
      {
        q: "Was kostet ein Kleintransport?",
        a: "Ab 89 € pro Stunde für einen Mann mit Transporter, ab 129 € pro Stunde mit 2 Mann. Einzelstücke (z. B. Sofa, IKEA-Abholung) ab 149 € pauschal im Wiener Raum. Längere Strecken berechnen wir nach Kilometer + Stundensatz.",
      },
      {
        q: "Gibt es ein Angebot oder rechnet ihr nach Stunden ab?",
        a: "Bei größeren Aufträgen (Entrümpelung, Wohnungsauflösung, Umzug) arbeiten wir grundsätzlich mit Angebot nach Besichtigung – keine Nachverrechnung, keine Überraschungen. Bei kurzen Kleintransporten ist Stundenabrechnung üblich und meist günstiger.",
      },
      {
        q: "Welche Zahlungsarten akzeptiert ihr?",
        a: "Bar, Bankomatkarte und Überweisung. Bei Firmenkunden mit Auftrag über 1.000 € auch Zahlung gegen Rechnung mit 14 Tagen Zahlungsziel.",
      },
      {
        q: "Stellt ihr Rechnung mit Umsatzsteuer aus?",
        a: "Ja, wir sind ein eingetragenes Einzelunternehmen mit UID-Nummer und stellen ordnungsgemäße Rechnungen mit 20 % USt aus. Privatpersonen können die Leistung im Trauerfall teilweise steuerlich absetzen – Details klärt Ihr Steuerberater.",
      },
    ],
  },
  {
    category: "Einsatzgebiet & Termine",
    items: [
      {
        q: "In welchem Umkreis seid ihr tätig?",
        a: "Hauptsächlich Wien (alle 23 Bezirke), Niederösterreich (Raum Wiener Neustadt, Mödling, Baden, Neunkirchen, Bruck/Leitha) und Burgenland (Bezirke Eisenstadt, Mattersburg). Auf Anfrage übernehmen wir auch österreichweite Umzüge und Übersiedlungen ins EU-Ausland.",
      },
      {
        q: "Wie schnell bekomme ich einen Termin?",
        a: "Besichtigungstermine sind in der Regel binnen 48 Stunden möglich, oft sogar am Folgetag. Den eigentlichen Räumungs- oder Umzugstermin koordinieren wir individuell – in Notfällen (kurzfristige Wohnungsübergabe, Trauerfall) arbeiten wir auch innerhalb von 24 Stunden.",
      },
      {
        q: "Arbeitet ihr auch an Samstagen oder Sonntagen?",
        a: "Ja, Samstags-Termine sind ohne Aufschlag möglich, Sonntags- und Feiertagstermine mit 20 % Zuschlag. Insbesondere Firmenumzüge wickeln wir oft am Wochenende ab, um Betriebsausfälle zu vermeiden.",
      },
      {
        q: "Macht ihr auch Auslandsumzüge?",
        a: "Ja, wir übersiedeln in den gesamten EU-Raum – am häufigsten Deutschland, Italien, Slowakei, Slowenien, Ungarn und Tschechien. Auslandsumzüge planen wir individuell mit Angebot und ggf. Zoll-Abwicklung.",
      },
    ],
  },
  {
    category: "Vorbereitung & Ablauf",
    items: [
      {
        q: "Welche Arbeiten muss ich vor der Entrümpelung durchführen?",
        a: "Grundsätzlich keine. Wenn Sie bestimmte Gegenstände behalten möchten, markieren Sie diese vorab oder zeigen Sie sie uns bei der Besichtigung – wir notieren das im Angebot. Persönliche Dokumente, Schmuck und Erinnerungsstücke sichern wir auf Wunsch separat.",
      },
      {
        q: "Muss ich beim Termin anwesend sein?",
        a: "Nein. Wir klären alles vor dem Termin schriftlich ab und können auf Wunsch die Schlüsselübernahme von der Hausverwaltung übernehmen. Sie erhalten eine Foto-Dokumentation vor und nach der Räumung. Gerade im Trauerfall oder bei Auslandsumzügen ist das für viele Kunden eine große Erleichterung.",
      },
      {
        q: "Wie läuft eine Wohnungsauflösung im Trauerfall ab?",
        a: "Wir vereinbaren ein einfühlsames Erstgespräch (telefonisch oder vor Ort), sichten gemeinsam mit Ihnen das Inventar, sichern Dokumente und Erinnerungsstücke, rechnen Wertgegenstände an und übergeben am Ende besenrein an die Hausverwaltung. Auf Wunsch komplett in Ihrer Abwesenheit.",
      },
      {
        q: "Bekomme ich eine Foto-Dokumentation?",
        a: "Ja, wir dokumentieren auf Wunsch den Vorher- und Nachher-Zustand fotografisch. Das ist besonders bei Wohnungsübergabe an Hausverwaltungen, bei Abwesenheit oder bei Auslandsabwicklungen wichtig.",
      },
    ],
  },
  {
    category: "Messie-Wohnungen & Spezialfälle",
    items: [
      {
        q: "Räumt ihr auch stark verdreckte Messie-Wohnungen?",
        a: "Ja, das ist eines unserer Spezialgebiete. Wir arbeiten mit Vollschutzausrüstung (PSA), koordinieren bei Bedarf Kammerjäger und Desinfektion und übernehmen auch die anschließende Grundreinigung und Geruchsneutralisation. Anfahrt erfolgt auf Wunsch absolut diskret mit unbeschriftetem Fahrzeug.",
      },
      {
        q: "Wahrt ihr die Diskretion gegenüber Nachbarn?",
        a: "Absolut. Auf Wunsch fahren wir mit unbeschriftetem Transporter an, bauen eine Schleuse im Stiegenhaus auf, arbeiten in neutraler Arbeitskleidung und kommunizieren nicht mit Nachbarn oder der Hausverwaltung über die Art des Auftrags.",
      },
      {
        q: "Räumt ihr auch nach Wasserschaden, Brand oder Todesfall?",
        a: "Ja. Wir übernehmen die fachgerechte Räumung nach Wasserschäden, Bränden und Todesfällen – inkl. Abtransport des Räumguts, Desinfektion und Übergabe an Versicherung oder Hausverwaltung. Die Abrechnung mit der Versicherung können wir auf Wunsch direkt übernehmen.",
      },
      {
        q: "Übernehmt ihr auch Verlassenschaften?",
        a: "Ja, Verlassenschaftsräumungen sind ein häufiger Auftrag bei uns. Wir koordinieren mit dem Notar bzw. Verlassenschaftskurator, sichern Dokumente und persönliche Erinnerungen, rechnen Wertgegenstände an und übergeben besenrein.",
      },
    ],
  },
  {
    category: "Demontage & Abtransport",
    items: [
      {
        q: "Welche Demontagen führt ihr durch?",
        a: "Wir demontieren Küchen (inkl. Anschluss-Trennung), Bäder, Bodenbeläge (Parkett, Laminat, Teppich), Wandfliesen, Einbauschränke, Regalsysteme und Lager-Einrichtungen. Teil-Entkernungen vor Sanierung sind ebenfalls möglich – inklusive Abtransport des Räumguts.",
      },
      {
        q: "Wohin kommt das Räumgut nach dem Abtransport?",
        a: "Wir räumen und transportieren ab. Das Räumgut übergeben wir ausschließlich an hierzu befugte Betriebe in Wien und NÖ; deren weitere Behandlung liegt nicht in unserer Hand. Auf Wunsch erhalten Sie eine Übernahmebestätigung.",
      },
      {
        q: "Rechnet ihr gut erhaltene Möbel an?",
        a: "Ja. Antiquitäten, Markenmöbel, hochwertige Designstücke, unbenutzte Elektrogeräte und Schmuck bewerten wir vor Ort und ziehen den Wert vom Auftragspreis ab. Bei einer typischen Wohnungsauflösung reduziert das den Endpreis um 10–30 %.",
      },
      {
        q: "Was passiert mit persönlichen Dokumenten und Fotos?",
        a: "Wir sichern alle persönlichen Dokumente, Fotos, Briefe und Erinnerungsstücke in beschrifteten Boxen und übergeben sie Ihnen oder verschicken sie auf Wunsch. Nichts davon wird ohne Ihre Zustimmung abtransportiert.",
      },
    ],
  },
  {
    category: "Versicherung & Sicherheit",
    items: [
      {
        q: "Sind unsere Möbel beim Transport versichert?",
        a: "Ja, standardmäßig sind alle Transporte bis 25.000 € pro Auftrag versichert. Für höhere Werte (Klavier, Antiquitäten, Kunst) erweitern wir die Deckung auf Wunsch und gegen Vorlage von Bewertungen.",
      },
      {
        q: "Was passiert bei einem Schaden?",
        a: "Sofortige Meldung an unsere Haftpflicht- und Transportversicherung, gemeinsame Schadensaufnahme mit Foto, Regulierung über die Versicherung. In den letzten Jahren hatten wir glücklicherweise nur sehr wenige Schadensfälle – und alle wurden ohne Diskussion reguliert.",
      },
      {
        q: "Welcher Fuhrpark ist vorhanden?",
        a: "Wir besitzen einen Pick-Up, einen großen Anhänger, einen Kleintransporter und einen Klein-LKW – ausgestattet mit Hebebühne, Sackkarre, Klaviertrolley, Decken und Spanngurten. Für größere Aufträge erweitern wir den Fuhrpark mit gemieteten 7,5 t-LKW.",
      },
      {
        q: "Sind eure Mitarbeiter geschult?",
        a: "Ja, alle Mitarbeiter sind in Möbelhandhabung, Ladungssicherung und sicherem Abtransport geschult. Für Messie-Räumungen verfügen sie zusätzlich über Schulungen in PSA-Vollschutz und Hygiene.",
      },
    ],
  },
];

// Flache Liste für Schema.org und Legacy-Komponenten
export const faqs: FaqItem[] = faqCategories.flatMap((c) => c.items);
